import { useAppSelector } from "@hypexone/uicore";
import React from "react";

const NoAccessPage: React.FC = () => {
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="flex justify-center items-center min-h-screen bg-blue1 p-4">
      <div className="text-white">{langData?.['access_redirect']}</div>
    </div>
  );
};

export default NoAccessPage;
